<template>
  <div :class="getContainerClass">
    <multiselect class="multiselect-styles" v-model="tags"  :placeholder="label"
                 label="name" track-by="id"
                 :options="options"
                 :multiple="true"
                 :taggable="false"
                 select-label=""
                 :loading="isLoading" :internal-search="true"
                 :close-on-select="false"
                 :hide-selected="true"
                 open-direction="bottom"
                 :searchable="true"
                 :options-limit="300" :limit="20"
    >
    </multiselect>
  </div>
</template>

<script>
import Field from '@/components/general/field'
import Multiselect from 'vue-multiselect'
import Hirers from '../../api/hirers'

export default {
  components: { Multiselect, Field },
  name: 'CompaniesAutocomplete',
  props: {
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    value: {
      type: Array,
      required: false
    },
    error: {
      type: String,
      default: null
    },
    options: {
      type: Array
    }
  },
  methods: {
    pgtDebounce (func, delay = 3000) {
      let debounceTimer
      return function () {
        const context = this
        const args = arguments
        clearTimeout(debounceTimer)
        debounceTimer = setTimeout(() => func.apply(context, args), delay)
      }
    },
    updateText (text) {
      this.updateSuggestions(text)
    },
    async updateSuggestions (text) {
      this.isLoading = true
      const { data } = await Hirers.getHirerJobBoards({q: text})
      this.isLoading = false
      this.options = [...data]
    }
  },
  computed: {
    tags: {
      get () { return this.value },
      set (value) {
        this.$emit('input', value)
      }
    },
    getContainerClass () {
      return this.options.length > 0 ? 'field tags flex-end' : 'field tags flex-end'
    }
  },
  mounted () {
    this.updateText = this.pgtDebounce(this.updateText, 3000)
  },
  data () {
    return {
      isLoading: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.row {
  padding: 0.5rem;
  &:hover {
    background-color: $hover-background;
    cursor: pointer;
  }
}
.field.is-grouped.is-grouped-multiline:last-child {
  margin-bottom: 0 !important;
}

.locationDropDown {
  margin-top: .5rem;
}

.mb-2{
  margin-bottom: 30px;
}

.mb{
  margin-bottom: 200px;
}
.mt-2{
  margin-top: 20px !important;
}
.mb-3{
  margin-bottom: 100px;
}
.flex-end{
  padding-top: 5px;
  display: flex;
  align-items: flex-end;
}

</style>
<style>
.multiselect {
  color: #363636;

}
.multiselect__tags{
  border-color: #dbdbdb !important;
}
.multiselect--active{
  border: 1px solid #44c7f0 !important;
  -webkit-box-shadow: inset 0 0 4px 0 #44c7f0 !important;
  box-shadow: inset 0 0 4px 0 #44c7f0 !important;
  border-radius: 3px;
}
.multiselect__content-wrapper{
  margin-top: 5px;
}

.multiselect__option--highlight{
  background-color: #44c7f0 !important;
}
.multiselect__tags-wrap > .multiselect__tag {
  border: solid 1px #ddd;
  color: #4a4a4a;
  background-color: #fff;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
}
.multiselect__tag-icon:after{
  color: #363636 !important;
}
.multiselect__tag-icon:hover {
  background: #fff !important;
}
.multiselect__tag-icon:hover:after{
  background-color: #fff;
  color: #363636 !important;
}

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/companies/companies-autocomplete.vue